import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Car } from '@sc/data-access-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarHttpService {
  private readonly apiUrl = '/api/car/fromLicensePlate';

  private readonly sidexaApiUrl = '/api/car/sidexa';

  constructor(private readonly httpClient: HttpClient) {}

  getCarData(carParams: {
    licensePlateNumber: string;
    damagedPart?: string;
  }): Observable<Car> {
    const { licensePlateNumber, damagedPart } = carParams;

    return this.httpClient.get<Car>(
      `${this.apiUrl}?licensePlateNumber=${licensePlateNumber}&damagedPart=${damagedPart}`,
      {
        headers: { requestName: 'car-http getCarData' },
      }
    );
  }

  getSidexaData(carParams: {
    licensePlateNumber: string;
    fitterId: string;
    glassType: string;
  }): Observable<any> {
    return this.httpClient.post(
      `${this.sidexaApiUrl}`,
      { ...carParams },
      {
        headers: { requestName: 'car-http getCarData', timeout: '30000' },
      }
    );
  }
}
